module.exports = __webpack_public_path__ + "static/media/Admin-11.1f979a9b.png";